module.exports = __webpack_public_path__ + "static/media/img-2.d3f08115.jpg";